import { ofType } from 'redux-observable';
import { catchError, concatMap, delay, map, switchMap } from 'rxjs/operators';
import { concat, defer, EMPTY, from, of, timer } from 'rxjs';
import {
  getDocumentsDueDiligence,
  setLoaders,
  setPopupInfo,
} from '../../data.action';
import { MODIFY_DOCUMENTS_DUE_DILIGENCE } from '../../index';
import { modifyDocumentDueDiligence } from '../../../../../services/http/documents.http-service';

const epic = (action$: any) =>
  action$.pipe(
    ofType(MODIFY_DOCUMENTS_DUE_DILIGENCE),
    map(({ payload }: any) => payload),
    switchMap((payload: any) =>
      concat(
        of(setLoaders({ uploadDocuments: true })),
        defer(() =>
          from(payload.documents).pipe(
            concatMap((p: any) =>
              from(
                modifyDocumentDueDiligence({
                  id: p?.id,
                  body: {
                    tag: payload?.progetto?.id,
                    category: payload?.categoria?.id,
                  },
                })
              ).pipe(
                switchMap(() => EMPTY),
                catchError(() => EMPTY)
              )
            )
          )
        ),
        of(
          getDocumentsDueDiligence({
            page: payload?.page,
            pageSize: payload?.pageSize,
          })
        ),
        of(setLoaders({ uploadDocuments: false })),
        of(
          setPopupInfo({
            opened: true,
            message: 'Aggiornamento completato con successo.',
          })
        ),
        timer(3000).pipe(
          switchMap(() =>
            of(
              setPopupInfo({
                opened: false,
                message: '',
              })
            )
          )
        )
      )
    )
  );

export default epic;
